import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Input } from '../ui/input';

const ALL = '__all';
const nextMonth = () => { const d = new Date(); d.setMonth(d.getMonth() + 1); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`; };
const STATUSES = [['valid', 'Valid'], ['due_soon', 'Due ≤60 days'], ['expired', 'Expired'], ['no_date', 'No date'], ['cancelled', 'Cancelled']];

const Pick = ({ value, onChange, placeholder, options, testId, width = 'w-44' }) => (
  <Select value={value || ALL} onValueChange={(v) => onChange(v === ALL ? '' : v)}>
    <SelectTrigger className={`h-9 ${width}`} data-testid={testId}><SelectValue placeholder={placeholder} /></SelectTrigger>
    <SelectContent>
      <SelectItem value={ALL}>{placeholder}</SelectItem>
      {options.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}
    </SelectContent>
  </Select>
);

export const VisaCostFilters = ({ f, setF, meta, employees }) => {
  const set = (k) => (v) => setF({ ...f, [k]: v });
  const thisYear = new Date().getFullYear();
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="visa-cost-filters">
      <Pick value={f.period} onChange={(v) => setF({ ...f, period: v, month: f.month || nextMonth(), year: f.year || String(thisYear + 1) })} placeholder="All renewal dates" width="w-40" testId="vc-filter-period"
        options={[['monthly', 'By month'], ['yearly', 'By year'], ['custom', 'Custom range']]} />
      {f.period === 'monthly' && <Input type="month" className="h-9 w-40" value={f.month} onChange={(e) => set('month')(e.target.value)} data-testid="vc-filter-month" />}
      {f.period === 'yearly' && (
        <Pick value={f.year} onChange={set('year')} placeholder="Select year" width="w-32" testId="vc-filter-year"
          options={[thisYear - 1, thisYear, thisYear + 1, thisYear + 2, thisYear + 3].map((y) => [String(y), String(y)])} />
      )}
      {f.period === 'custom' && (
        <>
          <Input type="date" className="h-9 w-40" value={f.start} onChange={(e) => set('start')(e.target.value)} data-testid="vc-filter-start" />
          <span className="text-xs text-gray-400">to</span>
          <Input type="date" className="h-9 w-40" value={f.end} onChange={(e) => set('end')(e.target.value)} data-testid="vc-filter-end" />
        </>
      )}
      <Pick value={f.employee_id} onChange={set('employee_id')} placeholder="All employees" width="w-52" testId="vc-filter-employee"
        options={employees.map((e) => [e.employee_id, `${e.employee_code} · ${e.name}`])} />
      <Pick value={f.department} onChange={set('department')} placeholder="All departments" testId="vc-filter-department"
        options={meta.departments.map((d) => [d, d])} />
      <Pick value={f.cost_centre_id} onChange={set('cost_centre_id')} placeholder="All cost centres" testId="vc-filter-cost-centre"
        options={meta.cost_centres.map((c) => [c.id, `${c.code} — ${c.name}`])} />
      <Pick value={f.status} onChange={set('status')} placeholder="All visa statuses" testId="vc-filter-status" options={STATUSES} />
    </div>
  );
};

export const filtersToParams = (f) => {
  const p = {};
  if (f.period === 'monthly' && f.month) Object.assign(p, { period: 'monthly', month: f.month });
  if (f.period === 'yearly' && f.year) Object.assign(p, { period: 'yearly', year: f.year });
  if (f.period === 'custom') Object.assign(p, { start: f.start, end: f.end });
  ['employee_id', 'department', 'cost_centre_id', 'status'].forEach((k) => { if (f[k]) p[k] = f[k]; });
  return p;
};
